// extracted by mini-css-extract-plugin
export var changeIcon = "_6l-4";
export var container = "_6l-0";
export var divider = "_6l-7";
export var externalLinkIcon = "_6l-1";
export var green = "_6l-5";
export var helpCircleIcon = "_6l-3";
export var iconButton = "_6l-2";
export var red = "_6l-6";